import { Component, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BrowserStorage } from "../core/storage";

@Component({
  standalone: false,
  selector: "app-cookies",
  templateUrl: "./cookies.component.html",
  styleUrls: ["./cookies.component.scss"],
})
export class CookiesComponent {
  @ViewChild("cookieDialog") cookieDialogRef: TemplateRef<any>;

  showCookiesBar = !BrowserStorage.getBoolean("acceptcookies", false, false);

  constructor(private dialog: MatDialog) {}

  openDetails(): void {
    this.dialog.open(this.cookieDialogRef, {
      width: "960px",
      maxWidth: "96vw",
    });
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  acceptCookies(): void {
    BrowserStorage.setBoolean("acceptcookies", true);
    BrowserStorage.setBoolean("acceptcookies", true, false);
    this.showCookiesBar = false;
    this.closeDialog();
  }
}
